import React, { useCallback, useEffect } from 'react'
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Image from '@tiptap/extension-image'
import ImageResize from 'tiptap-extension-resize-image'
import Link from '@tiptap/extension-link'

import './TipTap.css'

//MUI
import Stack from '@mui/material/Stack'
import ControlPanel from './ControlPanel'
import S3Image from './CustomImage'
import MuiAlert from './components/MuiAlert'

const extensions = [
  MuiAlert,
  S3Image,
  StarterKit.configure({
    image: false,
  }),
  Underline,
  Color,
  TextStyle,
  ImageResize,
  Link.configure({
    openOnClick: false,
    autolink: true,
    defaultProtocol: 'https',
    protocols: ['http', 'https'],
    shouldAutoLink: (url) => {
      try {
        // construct URL
        const parsedUrl = url.includes(':')
          ? new URL(url)
          : new URL(`https://${url}`)

        // only auto-link if the domain is not in the disallowed list
        const disallowedDomains = [
          'example-no-autolink.com',
          'another-no-autolink.com',
        ]
        const domain = parsedUrl.hostname

        return !disallowedDomains.includes(domain)
      } catch {
        return false
      }
    },
  }),
]

const TipTap = ({ value, onChange, isCRM }) => {
  const editor = useEditor({
    content: value,
    editable: true,
    onUpdate: ({ editor }) => {
      if (onChange) {
        onChange(editor.getHTML())
      }
    },
    extensions,
  })

  // Update editor content when `value` changes (e.g. loaded from API)
  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value)
    }
  }, [value, editor])

  if (!editor) {
    return null
  }

  return (
    <Stack>
      <ControlPanel editor={editor} isCRM={isCRM} />
      <EditorContent editor={editor} className="editor-content tiptap-reader" />
    </Stack>
  )
}

export default TipTap
